module.exports = __webpack_public_path__ + "static/media/new_login_bg_1.8f8c1104.png";